import React from 'react';
import { PersonData } from '../types';
import './DataPreview.css';

interface DataPreviewProps {
  data: PersonData[];
}

const DataPreview: React.FC<DataPreviewProps> = ({ data }) => {
  // Get all unique column names from the data
  const getColumnNames = () => {
    if (data.length === 0) return [];
    const allColumns = new Set<string>();
    data.forEach(item => {
      Object.keys(item).forEach(key => allColumns.add(key));
    });
    return Array.from(allColumns);
  };

  const columnNames = getColumnNames();

  return (
    <div className="data-preview">
      <h2>Pregled podataka ({data.length} stavki)</h2>
      
      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>#</th>
              {columnNames.map(columnName => (
                <th key={columnName}>{columnName}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.slice(0, 10).map((person, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                {columnNames.map(columnName => (
                  <td key={columnName}>{person[columnName] || ''}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      {data.length > 10 && (
        <p className="more-data">
          ... i još {data.length - 10} stavki
        </p>
      )}
    </div>
  );
};

export default DataPreview; 